import * as yup from 'yup'

export const positiveIntegerRequired = (label) =>
  yup
    .number()
    .typeError(`${label} must be a number`)
    .integer(`${label} must be an integer`)
    .positive(`${label} must be greater than 0`)
    .required(`${label} is required`)

export const dateRequired = (label) =>
  yup
    .string()
    .required(`${label} is required`)
    .test(
      'date-only-format',
      `${label} must be in YYYY-MM-DD format`,
      (value) => typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value),
    )
